/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import {
    object,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import { GRAPHQL_ENV } from '../../../../gql';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import BestSeller from '../../GraphqlTemplatePage/Partials/TemplateCollectionGiftGuides/BestSellerGiftGuide';

const  BestCollectionData = ({ brand, blockObj }) => {
    const collectionId = blockObj?.sub_collection_id;
    const subBrand = brand['domain-name'];
    const FINDCATEGORY_BY_ID = gql`
    query {
        findCategoryById(brand: "${subBrand}", id: "${collectionId}", environment: "development", locale: "en-us", productOptions:{page:1}) {
            name
            id
            products {
                id, name, image {name, path}, partNumber,
                availability {
                    deliveryMessage
                },
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {type, value},
                    retail {type, value}
                }
                seo {
                    url
                    title
                }
            }
        }
    }`;
    return (
        <Query query={FINDCATEGORY_BY_ID}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        query: FINDCATEGORY_BY_ID,
                        component: ' BestCollectionData.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' BestCollectionData.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data.findCategoryById || !data.findCategoryById.products) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' BestCollectionData.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                const graphqlProducts = data?.findCategoryById || null;
                return <BestSeller subNavCollection={graphqlProducts} bestSeller={blockObj}  />;
            }}
        </Query>

    );
};
BestCollectionData.propTypes = {
    brand: object.isRequired,
    blockObj: object.isRequired,
};
const mapStateToProps = (state) => ({
    brand: getBrand(state),
});
export default connect(mapStateToProps)(BestCollectionData);
